<template>
  <div v-show="isLoaded" class="mAge-gate-section" v-observe-visibility="startAnimate">

    <div class="mAge-gate-form">
      <img class="mLogo-age-gate" :class="{animate: animate}" :src="`${pathpublic}Logo_Strongbow.png`" alt="Logo de Strongbow" width="1538" height="941"/>
      <h1 class="enter-birthday" :class="{animate: animate}">Ingresa tu fecha</h1>
      <h2 class="enter-birthday" :class="{animate: animate}">de nacimiento</h2>
      <h3 class="enter-birthday-desktop" :class="{animate: animate}">Ingresa tu fecha de nacimiento</h3>

      <div class="mform-row" :class="{hasError: showWarning, animate: animate}">
        <input
          class="bold-dia"
          ref="day"
          type="tel"
          maxlength="2"
          placeholder="DD"
          v-on:keyup="focusNextSibling($event)"
          v-model="day"
        />
        <input
          class="bold-mes"
          ref="month"
          type="tel"
          maxlength="2"
          placeholder="MM"
          v-on:keyup="focusNextSibling($event)"
          v-model="month"
        />
        <input
          class="bold-año"
          ref="year"
          type="tel"
          maxlength="4"
          placeholder="AAAA"
          v-on:keyup="focusNextSibling($event)"
          v-model="year"
        />
        <div @click="normalLogin" :class="{animate: animate}" class="mLogin-desktop">
          <span>Entrar</span>
        </div>
       
      </div>
        <div @click="normalLogin" :class="{animate: animate}" class="mLogin">
          <span>Entrar</span>
        </div>
      <div class="with-facebook" :class="{animate: animate}" v-if="!showWarning">
        <h4>También puedes acceder usando una <br> red social o creando tu cuenta:</h4>
      </div>
      <div class="mFacebook-login" :class="{animate: animate}" v-if="!showWarning">
        <!--<p class="enter-with-facebook">O si prefieres, entra con</p>-->
        <FacebookButton
          v-on:fbLogin="fbLogin"
          v-on:noBirthdayInFacebook="noBirthdayInFacebook"
          isForResponsive="desktop"
        />
      </div>
      <div class="mFacebook-login" :class="{animate: animate}" v-if="showWarning">
        <p class="enter-with-facebook">
          Debes ser mayor de edad para navegar este sitio
        </p>
      </div>
    </div>
<!--     <div class="mAge-gate-footer" :class="{animate: animate}">
      <h4 class="privacy clickable" @click="popUpModal('terms')">
        Términos y Condiciones
      </h4>
      <span class="privacy bar">|</span>
      <h4 class="privacy clickable" @click="popUpModal('politics')">
        Aviso de Privacidad
      </h4>
      <span class="privacy bar">|</span>
      <h4 class="privacy desktop nohover">Evita el Exceso</h4>
      <div class="social-icons">
        <a
          class=""
          target="_blank"
          href="https://www.facebook.com/StrongbowMX/" @click="socialClick('Facebook','Interaction')"
          ><img :src="fbIconImage" alt="Facebook" width="43" height="42"
        /></a>
        <a
          class=""
          target="_blank"
          href="https://www.instagram.com/strongbow/" @click="socialClick('Instagram','Interaction')"
          ><img :src="inIconImage" alt="Instagram" width="43" height="42"
        /></a>
        <a class="" target="_blank" href="https://twitter.com/strongbowmx?lang=es" @click="socialClick('Twitter','Interaction')"
          ><img :src="twIconImage" alt="Twitter" width="43" height="42"
        /></a>
        <a
          class=""
          target="_blank"
          href="javascript:void(0)" @click="socialClick('Youtube','Interaction')"
          ><img :src="ytIconImage" alt="Youtube" width="43" height="42"
        /></a>
      </div>
      
    </div> -->
    <div class="mAge-gate-footer"> <Footer /></div>
       
    <Modal
      v-if="showModal"
      v-bind:wichModal="wichModal"
      @close="showModal = false"
    />
    
  </div>
</template>

<script>
//import Moment from "moment";
import Footer from "@/components/FooterHome.vue"
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import axios from "axios";
import Modal from "@/components/Modal";
import FacebookButton from "@/components/FacebookButton";


import tagFunctions from '@/utils/tagFunctions.js'


import {differenceInYears, format, parse, isValid} from 'date-fns'

export default {
  name: "AgeGate",
  components: {
    FacebookButton,
    Modal,
    Footer
  },
  data() {
    return {
      day: undefined,
      month: undefined,
      year: undefined,
      showWarning: false,
      showModal: false,
      wichModal: "terms",
      //response: undefined,
      response: null,
      pathpublic: process.env.BASE_URL,
      window: {
        width: 0,
        height: 0,
      },
      animate: false
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  computed: {
    ...mapGetters(["isLoaded"]),
  },
  methods: {
    startAnimate(isVisible){
      if(isVisible){
        this.animate=true
      }
    },
    ...mapActions({
      setAgeGateTokenAction: "setAgeGateToken",
    }),
     socialClick(socialNetwork, action){
      tagFunctions.evSocialNetworkPush(socialNetwork, action)
    },
    attemptAgeGate(){
      tagFunctions.evAgeGatePush('Intento')
    },
    passAgeGate(){
      tagFunctions.evAgeGatePush('Exito')
    },
    failAgeGate(errorMessage){
      tagFunctions.evAgeGatePush('Error', errorMessage)
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    noBirthdayInFacebook() {
      this.failAgeGate('La fecha de nacimiento no está disponible en Facebook')
      this.showWarning = true;
    },
    // fbLogin(response) {
    //   this.attemptAgeGate()
    //   // console.log(response);
    //   //const bDay = parse(`${response.birthday}`,'MM/dd/yyyy', new Date())
    //   //const today = new Date()
    //   //const age = differenceInYears(today, bDay)
    //   const minAge = response.age_range.min
    //   //window.sessionStorage.setItem('ageUser', age)
    //   //window.sessionStorage.setItem('ageUserBirthYear', format(bDay, 'yy'))
    //   window.sessionStorage.setItem("ageUser", minAge);
    //   window.sessionStorage.setItem("ageUserBirthYear", minAge);
    //   if (isNaN(minAge) || minAge < 18) {
    //     this.showWarning = true;
    //     this.failAgeGate('El usuario es menor de edad')
    //   } else {
    //     setTimeout(() => {
    //       axios
    //         .get(
    //           `https://cuamoc.xeerpa.com:8443/discoveruser?clientId=5f9926bc3b9e6e12501ce314&clientPwd=RNmB13d1hT&appId=611b8c03ef4487103845f4f1&socialNetwork=FB&userId=${response.authResponse.userID}&userToken=${response.authResponse.accessToken}`
    //         )
    //         .then((axiosResponse) => {
    //           this.response = axiosResponse;
    //           setTimeout(() => {
    //             this.setAgeGateTokenAction(true);
    //             window.sessionStorage.setItem('ageGateToken', true)
    //             window.sessionStorage.setItem('network', 'Facebook')
    //             this.passAgeGate()
    //           }, 200);
    //         })
    //         .catch((e) => {
    //           this.errors.push(e);
    //         });
    //     }, 100);
    //   }
    // },
    fbLogin() {},
    parseFlexibleDate(rawDate) {
      const formats = ['dd/MM/yyyy', 'MM/dd/yyyy', 'yyyy/MM/dd', 'yyyy/dd/MM', 'yyyy-MM-dd', 'yyyy-dd-MM', 'dd-MM-yyyy', 'MM-dd-yyyy' ];
      for (const formatStr of formats) {
        const parsed = parse(rawDate, formatStr, new Date());
        if (isValid(parsed)) {
          return parsed;
        }
      }
      const fallback = new Date(rawDate);
      return isValid(fallback) ? fallback : null;
    },
    xeerpaLogin() {
      this.attemptAgeGate()
      // Obtener el parámetro 't' desde la URL
      const paramT  = this.$route.query.t;
      if(paramT!= null) {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        var urlencoded = new URLSearchParams();
        urlencoded.append("t", paramT);

        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: urlencoded,
          redirect: 'follow'
        };

      fetch("https://login.heinekenmexico.com/api/connect/getUserData", requestOptions)
        .then(response => {
          // Primero, verifica si la respuesta de la red fue exitosa
          if (!response.ok) {
            // Si la respuesta no es OK (ej. 404, 500), lanza un error para que el bloque .catch lo maneje.
            throw new Error(`Error de red: ${response.status}`);
          }
          // Si la respuesta es exitosa, la convertimos a JSON.
          // Esto devuelve una promesa que resuelve con el objeto JSON parseado.
          return response.json();
        })
        .then(result => {
          //console.log("Objeto JSON completo:", result);
          // Si necesitas guardar todo el objeto en localStorage como JSON:
          localStorage.setItem('data', JSON.stringify(result));
          const social = result.data.sn;
          const location = result.data.formData.location;
          const rawBirthday = result.data.formData.birthday;
          console.log("birthday (crudo):", rawBirthday);
          // Acceder a la propiedad 'birthday' dentro de 'data' y 'formData'
          //const bDay = parse(`${result.data.formData.birthday}`,'dd/MM/yyyy', new Date());
          const bDay = this.parseFlexibleDate(rawBirthday);
          if (!bDay) {
            //console.error("No se pudo interpretar la fecha:", rawBirthday);
            this.showWarning = true;
            this.failAgeGate('Formato de fecha inválido');
            return;
          }
          //console.log("Fecha de cumpleaños (parseada):", bDay);
          const today = new Date()
          const age = differenceInYears(today, bDay)
          window.sessionStorage.setItem('ageUser', age)
          window.sessionStorage.setItem('ageUserBirthYear', format(bDay, 'yyyy'))
          window.sessionStorage.setItem('ageUserCountry', location)
          if (isNaN(age) || age < 18) {
            this.showWarning = true;
            this.failAgeGate('El usuario es menor de edad')
          } else {
            setTimeout(() => {
              this.setAgeGateTokenAction(true);
              window.sessionStorage.setItem('ageGateToken', true)
              window.sessionStorage.setItem('network', social)
              this.passAgeGate()
            }, 200);
          } 
        })
        .catch(error => console.log('Hubo un error en la petición o al procesar los datos:', error));
      }
    },
    popUpModal(modalType) {
      this.showModal = true;
      this.wichModal = modalType;
    },
    hideWarning() {
      this.showWarning = false;
    },
    normalLogin() {
      this.attemptAgeGate()
      const { day, month, year } = this;
      if (day && day !== "" && month && month !== "" && year && year !== "") {
        //const bDay = Moment(`${day}/${month}/${year}`, "DD/MM/YYYY");
        const bDay = parse(`${day}/${month}/${year}`, "dd/MM/yyyy", new Date());
        //const today = Moment();
        const today = new Date()
/*         const ageYear =
          Number(bDay.format("YYYY")) > Number(today.format("YYYY")); */
        const ageYear = Number(format(bDay,"yyyy")) > Number(format(today,"yyyy"));
        // console.log(ageYear);

        //const age = today.diff(bDay, "years", false);
        const age = differenceInYears(today, bDay)

      window.sessionStorage.setItem('ageUser', age)
      window.sessionStorage.setItem('ageUserBirthYear', format(bDay,'yy'))
        //console.log(age);
        if ((isNaN(age) || age < 18) && !ageYear) {
          this.showWarning = true;
          this.failAgeGate('El usuario es menor de edad')
        } else {
          setTimeout(() => {
            this.setAgeGateTokenAction(true);
            window.sessionStorage.setItem('ageGateToken', true)
            window.sessionStorage.setItem('network','Normal')
            this.passAgeGate()
          }, 100);
        }
      }
    },
    focusNextSibling(event) {
      const element = event.target;
      if (
        element &&
        element.value &&
        element.value.length === event.target.maxLength
      ) {
        event.target.nextElementSibling.focus();
      }
    },
  },
  mounted() {
    this.$nextTick(() => {});
    this.xeerpaLogin();
    this.$router.beforeEach((to, from, next) => {
      // console.log('q', to)
      if(to.path == '/politics' || to.path == '/cookies' || to.path == '/tycos'){
        this.setAgeGateTokenAction(true);
        next()
        //location.reload()
      }
      next()
    })
  },
};
</script>

<style scoped lang="scss">
@import "~@/styles/containers/agegatem.scss";
</style>
